import { PayloadAction } from '@reduxjs/toolkit';
import { ImageHandlingState } from '@reducers/v2/imageHandlingV2/imageHandlingV2.slice';
import { ImageContext, ImageDocumentStoreItem } from '@v2/components/imageHandling/types/types';

export interface DeletedImageData {
  document: ImageDocumentStoreItem;
  imageContext: ImageContext;
}

export const setNotSubmittedDeletedImageAction = (state: ImageHandlingState, action: PayloadAction<DeletedImageData | null>) => {
  state.notSubmittedDeletedImage = action.payload;
};
